/* global olark document */

var _require = require('../ccoConfigGet'),
  ccoConfigGet = _require.ccoConfigGet;
function init() {
  /*eslint-disable*/
  ;
  (function (o, l, a, r, k, y) {
    if (o.olark) return;
    r = "script";
    y = l.createElement(r);
    r = l.getElementsByTagName(r)[0];
    y.async = 1;
    y.src = "//" + a;
    r.parentNode.insertBefore(y, r);
    y = o.olark = function () {
      k.s.push(arguments);
      k.t.push(+new Date());
    };
    y.extend = function (i, j) {
      y("extend", i, j);
    };
    y.identify = function (i) {
      y("identify", k.i = i);
    };
    y.configure = function (i, j) {
      y("configure", i, j);
      k.c[i] = j;
    };
    k = y._ = {
      s: [],
      t: [+new Date()],
      c: {},
      l: a
    };
  })(window, document, "static.olark.com/jsclient/loader.js");
  /*eslint-enable*/
  /* Add configuration calls below this comment */
  olark.identify(ccoConfigGet('olarkSiteId', '9448-629-10-9786'));
  olark.configure('system.group', ccoConfigGet('olarkGroup'));
}
function onSuspendedLogin() {
  var messageDiv = document.querySelector('.olark-generated-message');
  var isOperatorActive = messageDiv && messageDiv.innerText.indexOf('Hi, I am around') === 0;
  if (isOperatorActive) {
    messageDiv.innerText = ccoConfigGet('chatMessageToVisitorOnSuspendedLogin', 'Hey there, it looks like this membership may have been deactivated. We can get this fixed for you ASAP. Enter your name and email below so we can chat about it.');
  } else {
    var offlineDiv = document.querySelector('.olark-form-message');
    if (offlineDiv) {
      offlineDiv.innerText = ccoConfigGet('chatMessageToVisitorOnSuspendedLoginWhenOperatorOffline', 'Hey there, it looks like this membership may have been deactivated. We can get this fixed for you ASAP. Leave us a message below and our team will get back to you. Our normal concierge hours are M-F, 9:30-5:30 ET.');
    }
  }
  olark('api.box.expand');
  olark('api.chat.onBeginConversation', function () {
    olark('api.chat.sendNotificationToOperator', {
      body: ccoConfigGet('chatMessageToOperatorOnSuspendedLogin', 'This is related to login / account suspension')
    });
  });
}
module.exports = {
  init: init,
  onSuspendedLogin: onSuspendedLogin
};